<spinner *ngIf="loading"></spinner>
<div *ngIf="!loading" class="page-container">
  <p-card>
    <div class="p-grid">
      <div class="p-col-12 p-d-flex p-ai-center p-jc-between">
        <h2>Prislistor</h2>
        <button
          pButton
          class="p-button-danger"
          label="Ta bort prislista"
          icon="pi pi-trash"
          [disabled]="!selectedPriceList"
          (click)="deleteSelected()"
        ></button>
      </div>

      <div class="p-col-12 p-lg-7">
        <div class="price-list-control">
          <p-dropdown
            [options]="priceLists"
            optionLabel="name"
            optionValue="id"
            [(ngModel)]="selectedPriceListId"
            (onChange)="setSelectedPriceList()"
            placeholder="Välj prislista"
            [style]="{ width: '100%' }"
          ></p-dropdown>
          <button
            pButton
            label="Redigera"
            icon="pi pi-pencil"
            [disabled]="!selectedPriceList"
            (click)="editSelectedPriceList()"
          ></button>
          <button
            pButton
            class="p-button-primary-hyperion"
            label="Skapa ny prislista"
            icon="pi pi-plus"
            (click)="createPriceList()"
          ></button>
        </div>
      </div>

      <div *ngIf="selectedPriceList" class="p-col-12 p-grid">
        <div class="p-col-12 p-lg-6">
          <h3>Yrkestyper</h3>
          <p-table [value]="selectedPriceList.userCostTypes">
            <ng-template pTemplate="header">
              <tr>
                <th>Namn</th>
                <th [style.width]="'12rem'">Timpris (kr/tim)</th>
              </tr>
            </ng-template>
            <ng-template let-row pTemplate="body">
              <tr>
                <td>{{ row.name }}</td>
                <td>
                  <input
                    pInputText
                    type="number"
                    min="0"
                    [(ngModel)]="row.cost"
                  />
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        <div class="p-col-12 p-lg-6">
          <h3>Kostnadstyper</h3>
          <p-table [value]="selectedPriceList.companyCostTypes">
            <ng-template pTemplate="header">
              <tr>
                <th>Namn</th>
                <th [style.width]="'12rem'">Påslag %</th>
              </tr>
            </ng-template>
            <ng-template let-row pTemplate="body">
              <tr>
                <td>{{ row.name }}</td>
                <td>
                  <input
                    pInputText
                    type="number"
                    min="0"
                    max="100"
                    step="0.01"
                    [(ngModel)]="row.procent"
                  />
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        <div class="p-col-12 p-d-flex p-jc-end p-mt-3">
          <button
            pButton
            class="p-button-primary-hyperion"
            label="Spara"
            icon="pi pi-save"
            [disabled]="!selectedPriceList"
            (click)="save()"
          ></button>
        </div>
      </div>
    </div>
  </p-card>
</div>

<p-dialog
  header="Skapa prislista"
  [(visible)]="showCreateDialog"
  [modal]="true"
  [style]="{ width: '28rem' }"
>
  <div class="p-fluid">
    <label>Namn</label>
    <input pInputText [(ngModel)]="newPriceListName" />
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      class="p-button-text"
      label="Avbryt"
      (click)="showCreateDialog = false"
    ></button>
    <button
      pButton
      class="p-button-primary-hyperion"
      label="Skapa"
      icon="pi pi-plus"
      [disabled]="!newPriceListName.trim()"
      (click)="confirmCreatePriceList()"
    ></button>
  </ng-template>
</p-dialog>

<p-dialog
  header="Redigera prislista"
  [(visible)]="showRenameDialog"
  [modal]="true"
  [style]="{ width: '28rem' }"
>
  <div class="p-fluid">
    <label>Namn</label>
    <input pInputText [(ngModel)]="renamePriceListName" />
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      class="p-button-text"
      label="Avbryt"
      (click)="showRenameDialog = false"
    ></button>
    <button
      pButton
      class="p-button-primary-hyperion"
      label="Spara"
      icon="pi pi-save"
      [disabled]="!renamePriceListName.trim()"
      (click)="confirmRenamePriceList()"
    ></button>
  </ng-template>
</p-dialog>
